import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { IOfferLetter } from '../type';

const DateAddress = ({
  joiningDate,
  address,
  fullName = '',
  contraction = '',
}: Omit<IOfferLetter, 'monthlySalary' | 'position'>) => {
  const sx = { fontFamily: 'Verdana', lineHeight: 1.2, fontSize: 15 };

  return (
    <Stack pt={7} spacing={2}>
      <Typography sx={{ ...sx }}>
        <b>{dayjs(joiningDate, 'DD/MM/YYYY').format('DD-MMM-YYYY')}</b>
      </Typography>
      <Stack spacing={0.7}>
        <Typography variant="subtitle1" sx={{ ...sx }}>{`${contraction}. ${fullName},`}</Typography>
        <Typography sx={{ ...sx }} width={220}>
          {address}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default DateAddress;
